<!-- Do not change this file. -->
<template>
  <div>
    <CustomAlert
      v-if="isDebugMode && 0"
      title="Debug"
      type="warning"
      :borderWidth="2"
    >
      <pre class="text-start">code: {{ code }}</pre>
      <pre class="text-start">codeObject: {{ codeObject }}</pre>
      <pre class="text-start">achievementObject: {{ achievementObject }}</pre>
      <pre class="text-start">mapToDatastore: {{ mapToDatastore }}</pre>
      <pre class="text-start">isAwarded: {{ isAwarded }}</pre>
    </CustomAlert>

    <div v-if="!isAwarded">
      <QuestionComponent
        v-bind="achievementObject"
        @updateScore="updateScore($event)"
      />
    </div>
    <div v-else>
      <CustomAlert title="Congratulations!" type="success" :borderWidth="2">
        You've earned a code for <b>{{ achievementObject.name }}</b
        >!

        <div class="p-3">
          <AchievementBadge :achievement="achievementObject" />
        </div>
      </CustomAlert>
      <div class="mb-3"></div>
      <RouterButton to="Achievements" label="Go to Achievements" icon="award" />
    </div>
  </div>
</template>

<script>
import DatastoreAPI from "@/helpers/DatastoreAPI";
import CustomAlert from "@/components/ui/CustomAlert.vue";
import AchievementBadge from "@/components/activity/AchievementBadge.vue";
import RouterButton from "@/components/activity/RouterButton.vue";

import content from "@/data/content";

import { mapGetters, mapActions } from "vuex";
import QuestionComponent from "@/components/reward/QuestionComponent.vue";

export default {
  name: "CodeValidator",
  mixins: [DatastoreAPI],
  components: {
    CustomAlert,
    QuestionComponent,
    AchievementBadge,
    RouterButton
  },
  data() {
    return {
      content,
      isAwarded: false
    };
  },
  props: {
    code: {
      type: String,
      required: true
    },
    codeObject: {
      type: Object
    },
    achievementObject: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(["mapToDatastore", "isDebugMode"])
  },
  methods: {
    ...mapActions(["addCode", "mapFromDatastore"]),
    updateScore(score) {
      this.awardCode(this.code, score);
      //console.log("Updating score:", this.code, score);

      if (score >= this.achievementObject.targetScore) {
        this.isAwarded = true;
      }
    },
    awardCode(code, score) {
      this.addCode({ code: code, score: score });

      // Update user entry in datastore
      this.updateEntry(this.mapToDatastore, () => {
        this.isReady = true;
      });
    }
  },
  mounted() {
    if (!this.codeObject?.score) {
      this.awardCode(this.code, 0);
    }

    if (
      this.codeObject?.score >= this.achievementObject.targetScore ||
      this.achievementObject.targetScore === 0
    ) {
      this.isAwarded = true;
    }
  }
};
</script>
